import React from "react";
import { useAuth } from "./AuthContext";

export default function GoogleSignIn() {
  const { setUser } = useAuth();

  async function handleClick() {
    const googleObj = (window as any).google;
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    const apiBase = process.env.REACT_APP_API_BASE;

    if (!googleObj || !clientId || !apiBase) {
      console.error("Google API object or environment variables missing.");
      return;
    }

    googleObj.accounts.id.initialize({
      client_id: clientId,
      callback: async (response: any) => {
        try {
          const res = await fetch(`${apiBase}/api/auth/google`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ IdToken: response.credential }),
          });
          const data = await res.json();
          setUser({ token: data.token, email: data.email });
        } catch (err) {
          console.error("Google login failed", err);
        }
      },
    });

    googleObj.accounts.id.prompt(); // triggers the Google popup
  }

  return (
    <button className="google" onClick={handleClick}>
      <img
        src="https://www.svgrepo.com/show/355037/google.svg"
        alt="Google logo"
        style={{ width: "20px", marginRight: "8px" }}
      />
      Sign in with Google
    </button>
  );
}

